/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/users-authz-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/users-authz-api-client";
import type { UsersAuthzAPIAdminPermissionsWriteDenyPermissionToUserMutationResponse, UsersAuthzAPIAdminPermissionsWriteDenyPermissionToUserPathParams } from "../models/UsersAuthzAPIAdminPermissionsWriteDenyPermissionToUser";

function getUsersAuthzAPIAdminPermissionsWriteDenyPermissionToUserUrl(userId: UsersAuthzAPIAdminPermissionsWriteDenyPermissionToUserPathParams["userId"], permission: UsersAuthzAPIAdminPermissionsWriteDenyPermissionToUserPathParams["permission"]) {
  const res = { method: 'POST', url: `/admin/user/${userId}/permissions/${permission}/deny` as const }  
  return res
}

/**
 * @summary Deny a permission for a user
 * {@link /admin/user/:userId/permissions/:permission/deny}
 */
export async function usersAuthzAPIAdminPermissionsWriteDenyPermissionToUser(userId: UsersAuthzAPIAdminPermissionsWriteDenyPermissionToUserPathParams["userId"], permission: UsersAuthzAPIAdminPermissionsWriteDenyPermissionToUserPathParams["permission"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<UsersAuthzAPIAdminPermissionsWriteDenyPermissionToUserMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getUsersAuthzAPIAdminPermissionsWriteDenyPermissionToUserUrl(userId, permission).url.toString(), ... requestConfig })  
  return res.data
}